/* eslint semi:0 */
import m from 'mithril'
import BaseVm from 'vms/BaseVm'
import GoogleSearchStore from 'stores/googleSearchStore'
import googleSearchActions from 'actions/googleSearchActions'


class GoogleSearchVm extends BaseVm {

  constructor(options = {}) {
    options.store = options.store || GoogleSearchStore.create()
    super(options)
    this.searchboxValue = m.prop('')
  }

  search(e) {
    e.preventDefault()
    googleSearchActions.searchClicked(this.searchboxValue())
  }
}

export default GoogleSearchVm


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/googleSearchVm.js